import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BusinessService } from '../../services/business.service';
import { UsersService } from '../../services/users.service';
import { map, take } from 'rxjs/operators';
import { ActivatedRoute, Router } from "@angular/router";
import { UtilsService } from 'projects/common/src/public-api';
import { NavigationService } from '../../services/navigation.service';
import { Subscription } from "rxjs";
import { ModalBehavior, ModalsService } from "../../../../../common/src/lib/services/modals.service";
import {
  ConfirmationDialog
} from "../../../../../common/src/lib/modals/confirmation-dialog/confirmation-dialog.component";

export const SettingsTabKey = 'Settings_Tab';
export const SettingsHighlightCourseKey = 'Settings_Highlight_Course';

export function highlightElement(element: HTMLElement) {
  if (!element) return;
  element.classList.remove("highlight-animation");

  void element.offsetWidth;

  element.classList.add("highlight-animation");

  setTimeout(() => {
    element.classList.remove("highlight-animation");
  }, 1000); // Match the duration of the animation
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {

  @ViewChild('videoCourseButton') videoCourseButton!: ElementRef<HTMLElement>;

  profile$ = this.businessService.selectedBusiness$;
  user$ = this.usersService.currentUser$.pipe(
    map(user => {
      if (!['owner', 'admin'].includes(user.role) && this.selectedTab === 'Users')
        this.onTabChange('Personal');
      return user;
    })
  );

  selectedTab = 'Personal';
  tabs$ = this.user$.pipe(
    map(currentUser => {
      if (currentUser && ['owner', 'admin'].includes(currentUser.role)) {
        return ['Personal', 'Business', 'Users', 'Help'];
      }
      return ['Personal', 'Business', 'Help'];
    })
  );

  tabletScreen$ = this.utilsService.onScreenBreakpointChange('sm');

  tabIndex = 0;

  backButtonCaption = 'Lobby';

  private paramSubscription: Subscription;

  constructor(
    private usersService: UsersService,
    private businessService: BusinessService,
    private router: Router,
    private utilsService: UtilsService,
    private navigationService: NavigationService,
    private route: ActivatedRoute,
    private modalsService: ModalsService,
  ) {
    this.paramSubscription = this.route.queryParams.pipe(
      map(paramMap => paramMap.qb_auth_success)
    ).subscribe(async qbAuthSuccess => {
      if (qbAuthSuccess) {
        this.onTabChange('Business').then();

        this.modalsService.open(ConfirmationDialog, {
          behavior: ModalBehavior.Dialog,
          data: {
            title: qbAuthSuccess === 'true' ? 'Success' : 'Failed',
            message: qbAuthSuccess === 'true'
              ? 'Quickbooks account was successfully connected to your business.'
              : 'Something went wrong during connecting Quickbooks Account to your business',
            actionTitle: 'Close',
            showCancelButton: false,
            action: () => {
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { qb_auth_success: null },
                queryParamsHandling: 'merge',
              });
            },
            actionColor: 'primary'
          }
        }).then();
      }
    });
  }

  async ngOnInit() {
    const initTab = localStorage.getItem(SettingsTabKey);
    if (initTab) {
      const availableTabs = await this.tabs$.pipe(take(1)).toPromise();
      if (availableTabs.includes(initTab)) {
        this.onTabChange(initTab)
      }
    }
    localStorage.removeItem(SettingsTabKey);
    if (this.navigationService.fromPaymentApplication)
      this.backButtonCaption = 'Back';
  }

  ngOnDestroy(): void {
    this.navigationService.clearBackRoute();
    this.paramSubscription.unsubscribe();
  }

  async backClick() {
    await (this.navigationService.fromPaymentApplication ? this.navigationService.goBack() : this.router.navigate(['/']));
  }

  async onTabChange(tab: string) {
    this.selectedTab = tab;
    const tabs = await this.tabs$.pipe(take(1)).toPromise();
    this.tabIndex = tabs.indexOf(tab);
    setTimeout(() => {
      if (tab == 'Help') {
        const highlight = localStorage.getItem(SettingsHighlightCourseKey);
        if (highlight === 'TRUE') {
          highlightElement(this.videoCourseButton.nativeElement);
          localStorage.removeItem(SettingsHighlightCourseKey);
        }
      }
    });
  }

}
